import { createApp } from 'vue';
import CommonPlugin from 'plugins/common-plugin';
import { i18n } from 'utils/i18n';
import store from 'stores/formulation-detail';
import FormulationDetailPage from 'views/formulation-repo/FormulationDetailPage.vue';

const app = createApp({
  components: {
    FormulationDetailPage
  }
});

app.use(CommonPlugin);
app.use(store);
app.use(i18n);

app.mount('#app');
